import React from 'react';
import PlusIMg from '../../../assets/images/plus.png';
import PlusIMgDark from '../../../assets/images/plusDark.png';

const AddAutomationBtn = ({ setOpenForm }) => {
  return (
    <div className='hunterTabContent'>
      <div className='emptyMessageSettings'>
        <p className='tabHeadingP automationHeading'>Automation</p>
        <div className='createBtn customizeBtn'>
          <button
            className='createButton gmNewBtn Lists' 
            id='autometion-create-btn'
            onClick={() => {
              setOpenForm((val) => true);
            }}
          >
            <img src={PlusIMgDark} className='plusImg' alt='' />
            Create New{' '}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddAutomationBtn;
